export default "__VITE_ASSET__CTrGnJs3__"